import React from 'react';
import {FaPrint} from "react-icons/fa6";
import {IoIosCloseCircle} from "react-icons/io";
import {IoWarning} from "react-icons/io5";
import {PiWarehouseFill} from "react-icons/pi";
import CardBox from "./CardBox";

const Boxes = ({data}) => {

    const unUsed = () => {
        let value = data?.printedCounter - (data?.registredCounter + data?.cancleCounter)
        if (value === 0) {
            return 0
        } else if (isNaN(value)) {
            return ''
        } else {
            return value
        }

    }
    return (
        <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-4 ">
                <CardBox title='چاپ شده' icon={<FaPrint color='blue' size={30}/>} bgColor='red'
                         value={data?.printedCounter}/>
                <CardBox title='تحویل به انبار' icon={<PiWarehouseFill color='green' size={30}/>} bgColor='red'
                         value={data?.registredCounter}/>
                <CardBox title='ابطال' icon={<IoIosCloseCircle color='red' size={30}/>} bgColor='red'
                         value={data?.cancleCounter}/>
                <CardBox title='استفاده نشده' icon={<IoWarning color='orange' size={30}/>} bgColor='red'
                         value={unUsed()}/>
            </div>
        </div>
    );
};

export default Boxes;